<template>
    <j-page>
        <div slot="search" @keydown.enter="searchEvent">
            <j-page-search title="主题">
                <el-input v-model.trim="query.title" placeholder="请输入主题" clearable />
            </j-page-search>
            <j-page-search title="应用名称">
                <j-dictionary type="select" v-model="query.modelKey" :dictionary="appNameDic" placeholder="请选择应用名称" />
            </j-page-search>
            <el-button type="primary" icon="el-icon-search" @click="searchEvent">查询</el-button>
            <el-button type="warning" icon="el-icon-plus" @click="addDgmxEvent">新增</el-button>
            <el-button type="info" icon="el-icon-refresh" @click="resetEvent">重置</el-button>
        </div>
        <div slot="table">
            <el-table v-loading="tableLoading" :data="tableData" @selection-change="tableSelectionChange" height="100%" stripe>
                <el-table-column prop="title" label="主题" align="center" show-overflow-tooltip />
                <el-table-column prop="description" label="描述" align="center" show-overflow-tooltip />
                <el-table-column prop="commendNum" label="点赞数量" align="center" show-overflow-tooltip />
                <el-table-column prop="modelKey" label="应用名称" align="center" show-overflow-tooltip>
                    <j-dictionary type="text" slot-scope="{row}" :value="row.modelKey" :dictionary="appNameDic" />
                </el-table-column>
                <el-table-column prop="iconMapId" label="应用图片" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">{{iconMap[row.iconMapId]}}</template>
                </el-table-column>
                <el-table-column label="操作" width="160">
                    <template slot-scope="scope">
                        <el-button @click.stop="detailDgmxEvent(scope.row)" type="text" class="common-button-detail">详情</el-button>
                        <el-button @click.stop="editDgmxEvent(scope.row)" type="text" class="common-button-edit">编辑</el-button>
                        <el-button @click.stop="delEvent(scope.row)" type="text" class="common-button-del" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div slot="pagination" v-show="query.total > query.limit">
            <el-pagination
                    :current-page="query.page"
                    :page-size="query.limit"
                    :total="query.total"
                    :background="pmxBackground"
                    :pager-count="pmxCount"
                    :layout="pmxLayout"
                    :pageSizes="pmxSizes"
                    @current-change="changePage"
                    @size-change="sizeChange"
            />
        </div>

        <!--        新增/编辑-->
        <el-dialog v-if="showDgmx" :title="dgmxTypeMap[dgmxType]" :visible.sync="showDgmx" width="750px" top="5%" :close-on-click-modal="false">
            <el-form ref="dgmxDom" :model="dgmxForm" :rules="dgmxRule" :label-width="dgmxFormLabelWidth" @keydown.native.enter="checkDgmxEvent('saveDgmxData')">
                <el-form-item label="主题" prop="title">
                    <el-input v-model.trim="dgmxForm.title" placeholder="请输入主题" maxlength="30" show-word-limit clearable />
                </el-form-item>
                <el-form-item label="描述" prop="description">
                    <el-input v-model.trim="dgmxForm.description" type="textarea" :rows="3" placeholder="请输入描述" maxlength="200" show-word-limit clearable />
                </el-form-item>
                <el-form-item label="应用名称" prop="modelKey">
                    <j-dictionary type="select" v-model="dgmxForm.modelKey" :dictionary="appNameDic" placeholder="请选择应用名称" />
                </el-form-item>
                <el-form-item label="应用图标" prop="iconMapId">
                    <el-select v-model="dgmxForm.iconMapId" placeholder="请选择应用图标" style="width: 100%" clearable filterable>
                        <el-option v-for="(value, key) in iconMap" :key="key" :label="value" :value="Number(key)" />
                    </el-select>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <j-editor :height="300" v-model="dgmxForm.content" />
                </el-form-item>
            </el-form>
            <template slot="footer">
                <el-button type="primary" @click="checkDgmxEvent('saveDgmxData')" :loading="submitLoad">保存</el-button>
                <el-button @click="showDgmx = false">取消</el-button>
            </template>
        </el-dialog>

        <!--        详情-->
        <el-dialog v-if="showDgmxDetail" :title="dgmxTypeMap[dgmxType]" :visible.sync="showDgmxDetail" width="500px" top="5%" :close-on-click-modal="false">
            <div class="common-dialog-title">基本信息</div>
            <el-form :model="curItem" :label-width="dgmxFormLabelWidth">
                <el-form-item label="主题">{{curItem.title}}</el-form-item>
                <el-form-item label="描述">{{curItem.description}}</el-form-item>
                <el-form-item label="应用名称">
                    <j-dictionary type="text" v-model="curItem.modelKey" :dictionary="appNameDic" />
                </el-form-item>
                <el-form-item label="应用图标" prop="iconMapId">{{iconMap[curItem.iconMapId]}}</el-form-item>
                <el-form-item label="内容" prop="content"><div v-html="curItem.content" /></el-form-item>
            </el-form>
            <template v-if="curItem.feedbacks">
                <div class="common-dialog-title">反馈信息</div>
                <el-table :data="curItem.feedbacks" border>
                    <el-table-column prop="createTime" label="反馈时间" />
                    <el-table-column prop="content" label="反馈内容" />
                    <el-table-column prop="attachment" label="反馈图片">
                        <j-file style="width: 30px;height: 30px;" slot-scope="{row}" type="card" :src="row.attachment" :name="row.content" />
                    </el-table-column>
                </el-table>
            </template>
        </el-dialog>
    </j-page>
</template>

<script>
    import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
    import PaginationMixins from "../../components/JComponents/JPage/mixins/PaginationMixins";
    import DialogMixins from "../../components/JComponents/JPage/mixins/DialogMixins";
    import JEditor from "../../components/JComponents/JEditor/JEditor";
    export default {
        name: "AppOrdinaryQuestions",
        mixins: [PageMixins, PaginationMixins, DialogMixins],
        components: {
            JEditor
        },
        data() {
            return {
                query: {
                    type: 'QUESTION',
                    modelKey: '',
                    title: ''
                },
                dgmxForm: {
                    title: '',
                    description: '',
                    content: '',
                    modelKey: '',
                    iconMapId: '',
                    type: "QUESTION"
                },
                dgmxRule: {
                    title: [{ required: true, message: '请输入主题', trigger: 'blur' }],
                    description: [{ required: true, message: '请输入描述', trigger: 'blur' }],
                    content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
                    modelKey: [{ required: true, message: '请选择应用名称', trigger: 'change' }],
                    iconMapId: [{ required: true, message: '请选择应用图标', trigger: 'change' }]
                },
                iconMap: {},
                appNameDic: [{"dictionaryItemId":7542,"key":"3","value":"待办任务","orderNo":0},{"dictionaryItemId":7527,"key":"2","value":"请假","orderNo":0},{"dictionaryItemId":7544,"key":"5","value":"格格故事","orderNo":0},{"dictionaryItemId":7545,"key":"6","value":"视频通话","orderNo":0},{"dictionaryItemId":7546,"key":"7","value":"操作指南","orderNo":0},{"dictionaryItemId":7547,"key":"8","value":"常见问题","orderNo":0},{"dictionaryItemId":7548,"key":"9","value":"标准地址","orderNo":0},{"dictionaryItemId":7549,"key":"10","value":"实有房屋","orderNo":0},{"dictionaryItemId":7550,"key":"11","value":"实有人口","orderNo":0},{"dictionaryItemId":7555,"key":"15","value":"办理中","orderNo":0},{"dictionaryItemId":7552,"key":"12","value":"实有单位","orderNo":0},{"dictionaryItemId":7553,"key":"13","value":"隐患排查","orderNo":0},{"dictionaryItemId":7554,"key":"14","value":"代办事项","orderNo":0},{"dictionaryItemId":7556,"key":"16","value":"已办结","orderNo":0},{"dictionaryItemId":7557,"key":"17","value":"党群服务","orderNo":0},{"dictionaryItemId":7558,"key":"18","value":"服务宣传","orderNo":0},{"dictionaryItemId":7559,"key":"19","value":"群众上报","orderNo":0},{"dictionaryItemId":7560,"key":"20","value":"市场服务","orderNo":0},{"dictionaryItemId":7524,"key":"0","value":"上下班打卡","orderNo":0},{"dictionaryItemId":7526,"key":"1","value":"日常巡查","orderNo":0},{"dictionaryItemId":7543,"key":"4","value":"汇总统计","orderNo":0}]
            }
        },
        created() {
            this.getAppIcon()
            this.load()
        },
        methods: {
            async getFeedbacks (row) {
                // const { data } = await this.$http.get(`/api/feedbacks/${row.questionGuideId}/list`)
                const data = {"code":200,"status":"yes","data":[{"feedbackId":62,"questionGuideId":101,"content":"123123","createTime":"2021-05-11 12:49:11","attachment":"/vux-img/db13a1505ad54b159e01e6f622af1d36.png&bucketName=grid||/vux-img/db13a1505ad54b159e01e6f622af1d36.png&bucketName=grid"},{"feedbackId":61,"questionGuideId":101,"content":"123123","createTime":"2021-05-11 12:48:58","attachment":"vux-img/308ad166ed96434eabfcbb9c3c77e98c.png&bucketName=grid"},{"feedbackId":63,"questionGuideId":101,"content":"gg","createTime":"2021-05-11 12:49:23","attachment":"vux-img/76b6008aabd5441bb3b3f9fbf92dbf1e.png&bucketName=grid"}]}
                return data.data || []
            },
            async getAppIcon () {
                // const { data } = await this.$http.get(`/api/iconMaps`)
                const icons = [{"iconMapId":11,"url":"icon/acd58907e3db441cab9be204fad39e5c.png&bucketName=grid","name":"实有房屋"},{"iconMapId":12,"url":"icon/ba6bc6ff72e84364bd4e5b70784e4ea5.png","name":"实有人口"},{"iconMapId":13,"url":"icon/b76e792c9471462cb04b39841e8397e1.png","name":"实有单位"},{"iconMapId":14,"url":"/icon/335235c459da4991816d5ea47dae31a4.png","name":"隐患排查"},{"iconMapId":8,"url":"/icon/2be82ab59ae14daea468bb4804c085dc.png","name":"汇总统计"},{"iconMapId":5,"url":"/icon/123a718dfaed40e890e87f00e249d9c7.png","name":"代办任务"},{"iconMapId":6,"url":"icon/27df99524192497f9f8fa207f9f790b2.png","name":"上下班打卡"},{"iconMapId":7,"url":"/icon/3aa778d61afe4dbeb568989257dfc28b.png","name":"格格故事"},{"iconMapId":9,"url":"icon/ca916d5bbfc44079b82c1b7612007304.jpg","name":"请假"},{"iconMapId":10,"url":"icon/02cad2468a894f4080437b71a4a4edfa.png","name":"日常巡查"},{"iconMapId":11,"url":"icon/acd58907e3db441cab9be204fad39e5c.png&bucketName=grid","name":"实有房屋"},{"iconMapId":22,"url":"/icon/5b74edb0fe894c58953fad0b14b48d4b.png","name":"汇总统计"},{"iconMapId":8,"url":"/icon/ffcf676a61e74529b6028c48787e9b57.png","name":"操作指南"},{"iconMapId":9,"url":"icon/ca916d5bbfc44079b82c1b7612007304.jpg","name":"请假"},{"iconMapId":10,"url":"icon/02cad2468a894f4080437b71a4a4edfa.png","name":"日常巡查"},{"iconMapId":15,"url":"/icon/d04fd490da83451f8561a55aeb761685.png","name":"办理中"},{"iconMapId":16,"url":"/icon/e586ff8f3845497ab6d406e8800dfa88.png","name":"待办事项"},{"iconMapId":17,"url":"/icon/b69122d1b0094a209ecfc6f21e0617e7.png","name":"已办结"},{"iconMapId":18,"url":"/icon/0e40796800d5487ca619f9720d7cbb10.png","name":"党群服务"},{"iconMapId":19,"url":"/icon/88c78db8fd014fe5a4b20cb597e20763.png","name":"服务宣传"},{"iconMapId":20,"url":"/icon/a4e7c5dd9bea4e85a7ac7ca6bc8b29f9.png","name":"群众上报"},{"iconMapId":28,"url":"/icon/d3a4b899c3a84cc5b14c2cad88cec8dc.png","name":"供暖问题排查"},{"iconMapId":23,"url":"/icon/ba86bd4e0a784b3da3fc8c193044fd0b.png","name":"实有房屋"},{"iconMapId":41,"url":"icon/8cfa49b00f944054a138cc62d978d1a0.png&bucketName=grid","name":"待上传"},{"iconMapId":61,"url":"icon/481da75931c7407c9d1f724ca7419913.png&bucketName=grid","name":"迁入核查"}]
                icons.forEach(icon => { this.iconMap[icon.iconMapId] = icon.name})
            },
            async load () {
                // this.tableLoading = true
                // const { data } = await this.$http.get(`/api/questionGuides`, {
                //     params: this.query
                // }).finally(() => {
                //     this.tableLoading = false
                // })
                // if (data.status !== 'yes') return this.$message.warning(data.msg || data.message || `接口异常`)
                // this.tableData = data.data.data
                // this.query.total = data.data.total
                // this.tableLoading = false
                this.tableData = [{"questionGuideId":101,"type":"QUESTION","modelKey":"1","title":"testst","iconMapId":6,"description":"testtaat","updateTime":"2020-12-04 17:26:43","createTime":"2020-12-04 17:26:43","commendNum":1},{"questionGuideId":81,"type":"QUESTION","modelKey":"0","title":"werwer","iconMapId":5,"description":"werwerwr","updateTime":"2020-05-07 15:28:37","createTime":"2020-04-26 18:47:26","commendNum":1},{"questionGuideId":21,"type":"QUESTION","modelKey":"1","title":"手机定位获取不到点位或是巡查点数较少如何处理","iconMapId":10,"description":"网格员开始巡查的时候，获取不到位置无法开始核查；定位轨迹偏差较大；或是日常巡查点数较少等问题，请按照如下说明设置；","updateTime":"2020-01-20 18:16:48","createTime":"2019-11-07 19:29:44","commendNum":2},{"questionGuideId":47,"type":"QUESTION","modelKey":"1","title":"网格员在自己网格内点击不了开始巡查","iconMapId":10,"description":"网格员现在位置正处于自己所负责的网格内，当前手机网络信号特别弱，一直点击不了开始巡查","updateTime":"2019-11-12 11:02:05","createTime":"2019-11-12 10:54:06","commendNum":1}]
            },
            async detailDgmxEvent (row) {
                this.dgmxType = 'DET'
                this.curItem = { ...row }
                this.curItem.feedbacks = await this.getFeedbacks(row)
                // this.curItem.content = await this.getDetailMetaData(`/api/questionGuides/${row.questionGuideId}/content`)
                this.showDgmxDetail = true
            },
            async editDgmxEvent (row) {
                this.dgmxType = 'EDIT'
                this.curItem = { ...row }
                // 详情接口填充详情数据
                // this.curItem.content = await this.getDetailMetaData(`/api/questionGuides/${row.questionGuideId}/content`)
                this.dgmxForm = this.proxyDgmxData({ ...this.dgmxForm, ...this.curItem })
                this.showDgmx = true
            },
            delEvent (row) {
                this.$confirm('您确认要删除当前记录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.request({ method: 'delete', url: `/api/questionGuides/${row.questionGuideId}`})
                        .then((res) => {
                            if (res.data.status !== 'yes') return this.$message.error(res.data.msg)
                            this.pageUpdate(this.query)
                            this.$message.success('删除成功')
                            this.load && this.load()
                        })
                })
            }
        }
    }
</script>
